import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { CartProvider } from "@/context/CartContext";
import { ProductImagesProvider } from "@/context/ProductImagesContext";
import Navbar from "@/components/Navbar";
import MetaPixel from "@/components/MetaPixel";
import CartDrawer from "@/components/CartDrawer";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Category from "@/pages/Category";
import Configurator from "@/pages/Configurator";
import BuilderLanding from "@/pages/BuilderLanding";
import Checkout from "@/pages/Checkout";
import BulkInquiry from "@/pages/BulkInquiry";
import Admin from "@/pages/Admin";
import Track from "@/pages/Track";
import PaymentResult from "@/pages/PaymentResult";
import Terms from "@/pages/Terms";
import WhatsAppButton from "@/components/WhatsAppButton";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const useLenis = () => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);
};

function App() {
  useLenis();
  return (
    <CartProvider>
      <ProductImagesProvider>
        <BrowserRouter>
        <ScrollToTop />
        <MetaPixel />
        <div className="min-h-screen bg-ink text-zinc-100 noise-overlay">
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop/:cat" element={<Category />} />
              <Route path="/shop/:cat/:sub" element={<Category />} />
              {/* Clean category entry points — alias paths bound to the Category layout */}
              <Route path="/apparel" element={<Category catAlias="custom-apparel" />} />
              <Route path="/embroidery" element={<Category catAlias="custom-bags-accessories" subAlias="hats" />} />
              <Route path="/flyers" element={<Category catAlias="business-printing" subAlias="flyers" />} />
              <Route path="/drinkware" element={<Category catAlias="custom-drinkware" />} />
              <Route path="/photogifts" element={<Category catAlias="photo-gift-items" />} />
              <Route path="/jerseys" element={<Category catAlias="custom-apparel" subAlias="jerseys" />} />
              <Route path="/promomerch" element={<Category catAlias="business-printing" subAlias="company-branded-merchandise" />} />
              <Route path="/stickers" element={<Category catAlias="business-printing" subAlias="stickers-labels" />} />
              <Route path="/builder" element={<BuilderLanding />} />
              <Route path="/configure/:type" element={<Configurator />} />
              <Route path="/product/:slug" element={<Configurator />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/bulk-inquiry" element={<BulkInquiry />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/track" element={<Track />} />
              <Route path="/payment-result" element={<PaymentResult />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppButton />
          <CartDrawer />
          <Toaster theme="dark" position="bottom-left" />
        </div>
        </BrowserRouter>
      </ProductImagesProvider>
    </CartProvider>
  );
}

export default App;
